import {Card, Text} from '@ui-kitten/components';
import React from 'react';
import {Image, StyleSheet} from 'react-native';
import {px, safeText} from '../../../utils';

// const starBanner = require('../../../assets/images/star_banner.jpg');

const Cover = ({imageUrl, title, price}) => {
  return (
    <Card>
      <Image
        source={{uri: imageUrl}}
        resizeMode="contain"
        style={styles.image}
      />
      <Text style={styles.title}>{safeText(title)}</Text>
      <Text style={styles.price}>
        {'RM ' + safeText(price)}
        {title === 'Package' ? ' for All Subjects' : ' Per Subject'}
      </Text>
    </Card>
  );
};

const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: px(230),
    backgroundColor: '#E8D3B3',
  },
  title: {
    fontSize: px(24),
    marginTop: px(17),
    paddingHorizontal: px(17),
  },
  price: {
    fontSize: px(18),
    marginTop: px(10),
    marginBottom: px(10),
    paddingHorizontal: px(17),
  },
});

export default Cover;
